import React from 'react';
import { Notification, toaster } from 'rsuite';
import Placeholder from 'rsuite/Placeholder';
import _ from 'lodash';
// eslint-disable-next-line no-unused-vars
const { Paragraph } = Placeholder;
const rsAlertContainer = {
    success: {
        backgroundColor: '#edfae1',
        color: '#575757'
    },
    info: {
        backgroundColor: '#e9f5fe',
        color: '#575757'
    },
    warning: {
        backgroundColor: '#fff9e6',
        color: '#575757'
    },
    error: {
        backgroundColor: '#fde9ef',
        color: '#575757'
    },

};

export const defaultErrorMsg = 'Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.';

const submitAllowed = [/* 'info', 'success', 'warning', */'error'];
/**
 * Alert toast
 * @param {String} type info | success | warning | error
 * @param {String} text
 * @param {Integer} duration time of closing notification. Do not automatically turn off notifications when the value is 0 (unit: milliseconds)
 * @param {String} placement topStart | topCenter | topEnd | bottomStart | bottomCenter | bottomEnd
 * @param {Function} submitToast function to submitToast toast (optional)
 * @param {Function} onClose function to close toast (optional)
 * @param  {...any} props
 * @returns An alert toast
 */
export const alert = (type, text, duration = 5000, placement = 'topCenter', submitToast, onClose, id, ...props) => {
    // Toaster with a notification modal onClose={onClose}
    return toaster.push(
        <Notification type={type} header={_.capitalize(type)} closable duration={duration} id={id} {...props} style={type ? rsAlertContainer[type] : {}} onClose={onClose && (() => onClose())}>
            {/* <Notification type={'success'} header={'success'} closable> */}
            {/* <Paragraph width={320} rows={3} /> */}
            {text}
            {(submitToast && submitAllowed.includes(type)) && (submitToast()) }
        </Notification>
        , {
            placement
        });
};

// Example of alerts
// alert('error'  , 'Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.', 5000);
// alert('success', 'Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.', 5000);
// alert('info'   , 'Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.', 5000);
// alert('warning', 'Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.', 5000);

// it was taken from rsuite/dist/styles/rsuit-default.css version 4.*.*
// .rs-alert-container .rs-alert-success .rs-alert-item-content {
//     background-color: #edfae1;
//     color: #575757;
//   }
//   .rs-alert-container .rs-alert-success .rs-alert-item-content .rs-icon {
//     color: #4caf50;
//   }
//   .rs-alert-container .rs-alert-success .rs-alert-item-close {
//     color: #4caf50;
//   }
//   .rs-alert-container .rs-alert-info .rs-alert-item-content {
//     background-color: #e9f5fe;
//     color: #575757;
//   }
//   .rs-alert-container .rs-alert-info .rs-alert-item-content .rs-icon {
//     color: #2196f3;
//   }
//   .rs-alert-container .rs-alert-info .rs-alert-item-close {
//     color: #2196f3;
//   }
//   .rs-alert-container .rs-alert-warning .rs-alert-item-content {
//     background-color: #fff9e6;
//     color: #575757;
//   }
//   .rs-alert-container .rs-alert-warning .rs-alert-item-content .rs-icon {
//     color: #ffb300;
//   }
//   .rs-alert-container .rs-alert-warning .rs-alert-item-close {
//     color: #ffb300;
//   }
//   .rs-alert-container .rs-alert-error .rs-alert-item-content {
//     background-color: #fde9ef;
//     color: #575757;
//   }
//   .rs-alert-container .rs-alert-error .rs-alert-item-content .rs-icon {
//     color: #f44336;
//   }
//   .rs-alert-container .rs-alert-error .rs-alert-item-close {
//     color: #f44336;
//   }
